const VEHICLE_WAFERS = '/vehicles/searchwafers'
const RUDAC = '/vehicles/searchwafers/exportrudac'
const DISARM = '/vehicles/searchwafers/exportdesarme'

export const searchwafersEndpoints = {
  VEHICLE_WAFERS,
  RUDAC,
  DISARM,
}
